export const decades = [
  {
    title: "1950",
    decade: "1950-1959",
    start: 1950,
    end: 1959
  },
  {
    title: "1960",
    decade: "1960-1969",
    start: 1960,
    end: 1969
  },
  {
    title: "1970",
    decade: "1970-1979",
    start: 1970,
    end: 1979
  },
  {
    title: "1980",
    decade: "1980-1989",
    start: 1980,
    end: 1989
  },
  {
    title: "1990",
    decade: "1990-1999",
    start: 1990,
    end: 1999
  },
  {
    title: "2000",
    decade: "2000-2009",
    start: 2000,
    end: 2009
  },
  {
    title: "2010",
    decade: "2010-2019",
    start: 2010,
    end: 2019
  },
  {
    title: "2020",
    decade: "2020-2029",
    start: 2020,
    end: 2029
  }
];